module.exports = __webpack_public_path__ + "img/hr-light-mud-decal-12.f7e80edb.png";